var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col",
      class: { "cursor-wait": _vm.downloadLoading }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "py-4 px-6 flex items-center justify-between border-b border-slate-400"
        },
        [
          _c("BlTextSubtitle2", {
            staticClass: "text-slate-700",
            attrs: { text: "Download report as PDF" }
          }),
          _vm._v(" "),
          _c("BlIcon", {
            staticClass: "h-6 w-6",
            attrs: { icon: "close", clickable: "" },
            on: {
              clicked: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "py-4 px-6 flex flex-col gap-3" },
        [
          _c("BlTextBody2", {
            attrs: {
              text:
                "Download your report as a PDF for easy sharing or offline review. Click the button below to generate the PDF file."
            }
          }),
          _vm._v(" "),
          _vm.downloadLoading
            ? _c("div", { staticClass: "h-16 grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader-btn" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("BlInputButton", {
            attrs: {
              label: "Download as PDF",
              type: "outlined",
              loading: _vm.downloadLoading
            },
            on: { clicked: _vm.onDownload }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bbfb1cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bbfb1cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/DownloadReport.vue
// module id = null
// module chunks = 